import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import {
  Icon,
  Button,
  Image,
  Label,
  Popup,
  Modal,
  Form,
  Message,
} from "semantic-ui-react";

import { useNavigate } from "react-router-dom";

import {
  auth,
  db,
} from "../firebase/firebaseConfig";

import { UserContext } from "../context/UserContext";

import format from "date-fns/format";
import { es } from "date-fns/locale";

import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";

import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  signOut,
  updatePassword,
  sendPasswordResetEmail,
} from "firebase/auth";

import { endSession } from "../components/session";
import { getLogoUrl } from "../utils/logoEmpresa";

export const NAV_HEIGHT = 70;

const NavbarSesionSemantic = () => {
  const { users } = useContext(UserContext);
  const navigate = useNavigate();
  const APP_ENV = process.env.REACT_APP_ENV;

  // ==========================================================
  // ESTADOS GENERALES
  // ==========================================================

  const [notificaciones, setNotificaciones] = useState([]);
  const [empresa, setEmpresa] = useState(null);

  // ==========================================================
  // POPUP USUARIO
  // ==========================================================

  const [popupUsuarioOpen, setPopupUsuarioOpen] =
    useState(false);

  // ==========================================================
  // CAMBIO DE CONTRASEÑA
  // ==========================================================

  const [modalPasswordOpen, setModalPasswordOpen] =
    useState(false);

  const [passwordActual, setPasswordActual] =
    useState("");

  const [passwordNueva, setPasswordNueva] =
    useState("");

  const [passwordConfirmacion, setPasswordConfirmacion] =
    useState("");

  const [mostrarActual, setMostrarActual] =
    useState(false);

  const [mostrarNueva, setMostrarNueva] =
    useState(false);

  const [mostrarConfirmacion, setMostrarConfirmacion] =
    useState(false);

  const [cambiandoPassword, setCambiandoPassword] =
    useState(false);

  const [enviandoRecuperacion, setEnviandoRecuperacion] =
    useState(false);

  const [errorPassword, setErrorPassword] =
    useState("");

  const [mensajePassword, setMensajePassword] =
    useState("");

  const [passwordCambiada, setPasswordCambiada] =
    useState(false);

  // ==========================================================
  // FECHA
  // ==========================================================

  const fechaActual = format(
    new Date(),
    "dd 'de' MMMM 'de' yyyy",
    {
      locale: es,
    }
  );

  // ==========================================================
  // EMPRESA
  // ==========================================================

  useEffect(() => {
    if (!users?.emp_id) return;

    const empresaRef = doc(
      db,
      "empresas",
      users.emp_id
    );

    const unsub = onSnapshot(
      empresaRef,
      (snap) => {
        if (snap.exists()) {
          setEmpresa({
            id: snap.id,
            ...snap.data(),
          });
        } else {
          setEmpresa(null);
        }
      }
    );

    return () => unsub();
  }, [users?.emp_id]);

  // ==========================================================
  // NOTIFICACIONES
  // ==========================================================

  useEffect(() => {
    if (!users?.correo || !users?.emp_id) return;

    const q = query(
      collection(db, "notificaciones"),
      where("emp_id", "==", users.emp_id),
      where(
        "para",
        "array-contains",
        users.correo
      )
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map(
          (docItem) => ({
            id: docItem.id,
            ...docItem.data(),
          })
        );

        setNotificaciones(data);
      }
    );

    return () => unsub();
  }, [
    users?.correo,
    users?.emp_id,
  ]);

  // ==========================================================
  // NOTIFICACIONES NO LEÍDAS
  // ==========================================================

  const notificacionesNoLeidas =
    notificaciones.filter(
      (n) =>
        !n.leidoPor?.includes(
          users?.correo
        )
    );

  const noLeidas =
    notificacionesNoLeidas.length;

  // ==========================================================
  // CERRAR SESIÓN
  // ==========================================================

  const cerrarSesion = async () => {
    try {
      setPopupUsuarioOpen(false);

      await endSession(
        auth.currentUser
      );

      await signOut(auth);

      localStorage.clear();

      navigate("/");
    } catch (error) {
      console.error(
        "Error al cerrar sesión:",
        error
      );
    }
  };

  // ==========================================================
  // MARCAR NOTIFICACIÓN LEÍDA
  // ==========================================================

  const marcarComoLeida =
    async (notificacion) => {
      try {
        if (!users?.correo) return;

        await updateDoc(
          doc(
            db,
            "notificaciones",
            notificacion.id
          ),
          {
            leidoPor: arrayUnion(
              users.correo
            ),
          }
        );

        if (notificacion.link) {
          navigate(
            notificacion.link
          );
        }
      } catch (error) {
        console.error(
          "Error al marcar notificación:",
          error
        );
      }
    };

  // ==========================================================
  // LIMPIAR FORMULARIO PASSWORD
  // ==========================================================

  const limpiarPassword = () => {
    setPasswordActual("");
    setPasswordNueva("");
    setPasswordConfirmacion("");

    setMostrarActual(false);
    setMostrarNueva(false);
    setMostrarConfirmacion(false);

    setErrorPassword("");
    setMensajePassword("");
    setPasswordCambiada(false);
  };

  // ==========================================================
  // ABRIR CAMBIO PASSWORD
  // ==========================================================

  const abrirCambioPassword = () => {
    setPopupUsuarioOpen(false);

    limpiarPassword();

    setModalPasswordOpen(true);
  };

  // ==========================================================
  // CERRAR MODAL
  // ==========================================================

  const cerrarModalPassword = () => {
    if (
      cambiandoPassword ||
      enviandoRecuperacion
    ) {
      return;
    }

    setModalPasswordOpen(false);

    limpiarPassword();
  };

  // ==========================================================
  // VALIDACIÓN PASSWORD
  // ==========================================================

  const validarNuevaPassword = () => {
    if (!passwordActual) {
      return "Debe ingresar su contraseña actual.";
    }

    if (!passwordNueva) {
      return "Debe ingresar la nueva contraseña.";
    }

    if (passwordNueva.length < 8) {
      return "La nueva contraseña debe tener al menos 8 caracteres.";
    }

    if (!/[A-Z]/.test(passwordNueva)) {
      return "La nueva contraseña debe contener al menos una letra mayúscula.";
    }

    if (!/[a-z]/.test(passwordNueva)) {
      return "La nueva contraseña debe contener al menos una letra minúscula.";
    }

    if (!/[0-9]/.test(passwordNueva)) {
      return "La nueva contraseña debe contener al menos un número.";
    }

    if (
      passwordNueva !==
      passwordConfirmacion
    ) {
      return "La nueva contraseña y su confirmación no coinciden.";
    }

    if (
      passwordActual ===
      passwordNueva
    ) {
      return "La nueva contraseña debe ser diferente de la contraseña actual.";
    }

    return "";
  };

  // ==========================================================
  // MENSAJES FIREBASE
  // ==========================================================

  const obtenerMensajeErrorPassword = (
    error
  ) => {
    const code = String(
      error?.code || ""
    );

    if (
      code.includes(
        "wrong-password"
      ) ||
      code.includes(
        "invalid-credential"
      )
    ) {
      return "La contraseña actual ingresada no es correcta.";
    }

    if (
      code.includes(
        "weak-password"
      )
    ) {
      return "La nueva contraseña no cumple los requisitos de seguridad.";
    }

    if (
      code.includes(
        "too-many-requests"
      )
    ) {
      return "Se realizaron demasiados intentos. Espere unos minutos e inténtelo nuevamente.";
    }

    if (
      code.includes(
        "requires-recent-login"
      )
    ) {
      return "Firebase requiere volver a validar la sesión.";
    }

    if (
      code.includes(
        "network-request-failed"
      )
    ) {
      return "No fue posible conectar con Firebase. Revise su conexión a Internet.";
    }

    if (
      code.includes(
        "user-disabled"
      )
    ) {
      return "Esta cuenta se encuentra deshabilitada.";
    }

    return (
      error?.message ||
      "No fue posible realizar la operación."
    );
  };

  // ==========================================================
  // CAMBIAR CONTRASEÑA
  // ==========================================================

  const cambiarPassword = async () => {
    if (
      cambiandoPassword ||
      enviandoRecuperacion
    ) {
      return;
    }

    setErrorPassword("");
    setMensajePassword("");
    setPasswordCambiada(false);

    const mensajeValidacion =
      validarNuevaPassword();

    if (mensajeValidacion) {
      setErrorPassword(
        mensajeValidacion
      );

      return;
    }

    try {
      setCambiandoPassword(true);

      const usuarioActual =
        auth.currentUser;

      if (
        !usuarioActual ||
        !usuarioActual.email
      ) {
        throw new Error(
          "No existe una sesión de usuario válida."
        );
      }

      // ======================================================
      // 1. GENERAR CREDENCIAL
      // ======================================================

      const credential =
        EmailAuthProvider.credential(
          usuarioActual.email,
          passwordActual
        );

      // ======================================================
      // 2. REAUTENTICAR
      // ======================================================

      await reauthenticateWithCredential(
        usuarioActual,
        credential
      );

      // ======================================================
      // 3. CAMBIAR CONTRASEÑA
      // ======================================================

      await updatePassword(
        usuarioActual,
        passwordNueva
      );

      // ======================================================
      // 4. RESULTADO
      // ======================================================

      setPasswordActual("");
      setPasswordNueva("");
      setPasswordConfirmacion("");

      setErrorPassword("");

      setMensajePassword(
        "Su contraseña fue actualizada correctamente."
      );

      setPasswordCambiada(true);
    } catch (error) {
      console.error(
        "Error cambiando contraseña:",
        error
      );

      setErrorPassword(
        obtenerMensajeErrorPassword(
          error
        )
      );
    } finally {
      setCambiandoPassword(false);
    }
  };

  // ==========================================================
  // RECUPERAR CONTRASEÑA
  // ==========================================================

  const enviarRecuperacionPassword =
    async () => {
      if (
        cambiandoPassword ||
        enviandoRecuperacion
      ) {
        return;
      }

      try {
        setErrorPassword("");
        setMensajePassword("");
        setPasswordCambiada(false);

        setEnviandoRecuperacion(true);

        const usuarioActual =
          auth.currentUser;

        if (!usuarioActual?.email) {
          throw new Error(
            "No existe un correo asociado a la sesión actual."
          );
        }

        await sendPasswordResetEmail(
          auth,
          usuarioActual.email
        );

        setPasswordActual("");
        setPasswordNueva("");
        setPasswordConfirmacion("");

        setMensajePassword(
          `Se envió un correo de recuperación a ${usuarioActual.email}. Revise también su carpeta de Spam.`
        );
      } catch (error) {
        console.error(
          "Error enviando recuperación de contraseña:",
          error
        );

        setErrorPassword(
          obtenerMensajeErrorPassword(
            error
          )
        );
      } finally {
        setEnviandoRecuperacion(false);
      }
    };

  // ==========================================================
  // REGLAS DE PASSWORD
  // ==========================================================

  const reglaLargo =
    passwordNueva.length >= 8;

  const reglaMayuscula =
    /[A-Z]/.test(passwordNueva);

  const reglaMinuscula =
    /[a-z]/.test(passwordNueva);

  const reglaNumero =
    /[0-9]/.test(passwordNueva);

  const reglaCoinciden =
    passwordNueva !== "" &&
    passwordNueva ===
    passwordConfirmacion;

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: NAV_HEIGHT,
          background: "#D9D9D9",
          zIndex: 3000,
          boxShadow:
            "0 1px 0 rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            height: "100%",
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          {/* =============================================== */}
          {/* IZQUIERDA */}
          {/* =============================================== */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 20,
            }}
            title="v2.0.0"
          >
            <Image
              src="/logo.png"
              alt="Logo LogisticMed"
              style={{
                height: 44,
                width: "auto",
                objectFit: "contain",
              }}
            />
            {["DESARROLLO", "QA"].includes(APP_ENV) && (
              <Label
                size="tiny"
                color={APP_ENV === "QA" ? "orange" : "blue"}
                style={{
                  margin: 0,
                  fontWeight: 700,
                  letterSpacing: "0.4px",
                }}
              >
                {APP_ENV}
              </Label>
            )}
            {users?.emp_id && (
              <Image
                src={getLogoUrl(
                  empresa?.logoUrl,
                  empresa?.versionLogo
                )}
                alt={
                  empresa?.empresa ||
                  "Logo Empresa"
                }
                className="hide-mobile"
                style={{
                  width: 120,
                  maxHeight: 46,
                  objectFit: "contain",
                  background:
                    "transparent",
                }}
                onError={(e) => {
                  e.currentTarget.src =
                    "/logo-default.png";
                }}
              />
            )}
          </div>

          {/* =============================================== */}
          {/* CENTRO */}
          {/* =============================================== */}

          <div
            className="hide-tablet"
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent:
                "center",
              gap: 120,
              fontSize: 14,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems:
                  "center",
                gap: 8,
              }}
            >
              <Icon name="building outline" />

              <span>
                Empresa:{" "}
                <b>
                  {empresa?.empresa ||
                    users?.empresa ||
                    "-"}
                </b>
              </span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems:
                  "center",
                gap: 8,
              }}
            >
              <Icon name="calendar alternate outline" />

              <span>
                {fechaActual}
              </span>
            </div>
          </div>

          {/* =============================================== */}
          {/* DERECHA */}
          {/* =============================================== */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              marginLeft: "auto",
            }}
          >
            {/* ============================================= */}
            {/* USUARIO */}
            {/* ============================================= */}

            <Popup
              on="click"
              position="bottom right"
              basic
              wide
              open={popupUsuarioOpen}
              onOpen={() =>
                setPopupUsuarioOpen(
                  true
                )
              }
              onClose={() =>
                setPopupUsuarioOpen(
                  false
                )
              }
              trigger={
                <div
                  style={{
                    display: "flex",
                    alignItems:
                      "center",
                    gap: 10,
                    cursor:
                      "pointer",
                    padding:
                      "6px 9px",
                    borderRadius: 7,
                  }}
                  title="Mi cuenta"
                >
                  <Icon
                    name="user circle"
                    size="large"
                    style={{
                      color:
                        "#328AC4",
                      margin: 0,
                    }}
                  />

                  <div
                    className="hide-mobile"
                    style={{
                      lineHeight: 1.1,
                      textAlign:
                        "right",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight:
                          700,
                      }}
                    >
                      {`${users?.nombre || ""} ${users?.apellido ||
                        ""
                        }`.trim()}
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        opacity: 0.85,
                        marginTop: 3,
                      }}
                    >
                      {users?.rol
                        ? `(${users.rol})`
                        : ""}
                    </div>
                  </div>

                  <Icon
                    className="hide-mobile"
                    name="angle down"
                    style={{
                      margin: 0,
                      color:
                        "#697586",
                    }}
                  />
                </div>
              }
            >
              <div
                style={{
                  width: 260,
                }}
              >
                {/* CABECERA */}

                <div
                  style={{
                    display: "flex",
                    alignItems:
                      "center",
                    gap: 10,
                    paddingBottom:
                      12,
                    borderBottom:
                      "1px solid #edf0f4",
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius:
                        "50%",
                      background:
                        "#e5f7f7",
                      display: "flex",
                      alignItems:
                        "center",
                      justifyContent:
                        "center",
                    }}
                  >
                    <Icon
                      name="user"
                      style={{
                        color:
                          "#0d9da5",
                        margin: 0,
                      }}
                    />
                  </div>

                  <div
                    style={{
                      minWidth: 0,
                    }}
                  >
                    <div
                      style={{
                        color:
                          "#253858",
                        fontWeight:
                          700,
                        fontSize: 13,
                      }}
                    >
                      {`${users?.nombre || ""} ${users?.apellido ||
                        ""
                        }`.trim() ||
                        "Usuario"}
                    </div>

                    <div
                      style={{
                        color:
                          "#8793a5",
                        fontSize: 11,
                        marginTop: 2,
                        overflow:
                          "hidden",
                        textOverflow:
                          "ellipsis",
                        whiteSpace:
                          "nowrap",
                      }}
                    >
                      {users?.correo ||
                        auth.currentUser
                          ?.email ||
                        ""}
                    </div>

                    <div
                      style={{
                        color:
                          "#2185d0",
                        fontSize: 10,
                        fontWeight:
                          700,
                        marginTop: 3,
                      }}
                    >
                      {users?.rol || ""}
                    </div>
                  </div>
                </div>

                {/* CAMBIAR PASSWORD */}

                <Button
                  fluid
                  basic
                  type="button"
                  onClick={
                    abrirCambioPassword
                  }
                  style={{
                    border: "none",
                    boxShadow:
                      "none",
                    textAlign:
                      "left",
                    padding:
                      "11px 10px",
                    color:
                      "#344563",
                  }}
                >
                  <Icon
                    name="key"
                    style={{
                      color:
                        "#f2711c",
                    }}
                  />

                  Cambiar contraseña
                </Button>

                {/* CERRAR SESION */}

                <Button
                  fluid
                  basic
                  type="button"
                  onClick={cerrarSesion}
                  style={{
                    border: "none",
                    boxShadow:
                      "none",
                    textAlign:
                      "left",
                    padding:
                      "11px 10px",
                    color:
                      "#db2828",
                  }}
                >
                  <Icon
                    name="sign-out"
                    color="red"
                  />

                  Cerrar sesión
                </Button>
              </div>
            </Popup>

            {/* ============================================= */}
            {/* NOTIFICACIONES */}
            {/* ============================================= */}

            <Popup
              on="click"
              position="bottom right"
              basic
              wide
              trigger={
                <div
                  style={{
                    position:
                      "relative",
                    cursor:
                      "pointer",
                    width: 34,
                    height: 34,
                    borderRadius:
                      "50%",
                    display: "flex",
                    alignItems:
                      "center",
                    justifyContent:
                      "center",
                  }}
                  title="Notificaciones"
                >
                  <Icon
                    name="bell outline"
                    style={{
                      color:
                        "#328AC4",
                      fontSize: 22,
                      margin: 0,
                    }}
                  />

                  {noLeidas > 0 && (
                    <Label
                      circular
                      color="red"
                      size="mini"
                      style={{
                        position:
                          "absolute",
                        top: -3,
                        right: -3,
                        fontSize: 10,
                        minWidth: 18,
                        minHeight: 18,
                        padding:
                          "3px 5px",
                        display:
                          "flex",
                        alignItems:
                          "center",
                        justifyContent:
                          "center",
                      }}
                    >
                      {noLeidas}
                    </Label>
                  )}
                </div>
              }
            >
              <div
                style={{
                  width: 280,
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    marginBottom:
                      12,
                    color: "#333",
                  }}
                >
                  Notificaciones
                </div>

                {notificacionesNoLeidas.length ===
                  0 ? (
                  <div
                    style={{
                      fontSize: 13,
                      color: "#777",
                    }}
                  >
                    No tienes notificaciones
                  </div>
                ) : (
                  notificacionesNoLeidas.map(
                    (n) => (
                      <div
                        key={n.id}
                        style={{
                          padding:
                            "10px 0",
                          borderTop:
                            "1px solid #eee",
                          cursor:
                            "pointer",
                        }}
                        onClick={() =>
                          marcarComoLeida(
                            n
                          )
                        }
                      >
                        <div
                          style={{
                            fontWeight:
                              700,
                            fontSize:
                              14,
                          }}
                        >
                          {n.titulo}
                        </div>

                        <div
                          style={{
                            fontSize:
                              12,
                            color:
                              "#666",
                            marginTop:
                              3,
                          }}
                        >
                          {n.mensaje}
                        </div>
                      </div>
                    )
                  )
                )}
              </div>
            </Popup>
          </div>
        </div>

        {/* =============================================== */}
        {/* RESPONSIVE */}
        {/* =============================================== */}

        <style>{`
          @media (max-width: 768px){
            .hide-tablet{
              display:none !important;
            }
          }

          @media (max-width: 576px){
            .hide-mobile{
              display:none !important;
            }
          }
        `}</style>
      </div>

      {/* ================================================== */}
      {/* MODAL PASSWORD COMPACTO */}
      {/* ================================================== */}

      <Modal
        open={modalPasswordOpen}
        onClose={cerrarModalPassword}
        closeOnEscape={
          !cambiandoPassword &&
          !enviandoRecuperacion
        }
        closeOnDimmerClick={
          !cambiandoPassword &&
          !enviandoRecuperacion
        }
        style={{
          width: 440,
          maxWidth: "94vw",
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <Modal.Header
          style={{
            padding: "12px 16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 8,
                background: "#fff3e7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon
                name="key"
                style={{
                  margin: 0,
                  color: "#f2711c",
                  fontSize: 15,
                }}
              />
            </div>

            <div>
              <div
                style={{
                  color: "#172b4d",
                  fontSize: 15,
                  fontWeight: 700,
                }}
              >
                Cambiar contraseña
              </div>

              <div
                style={{
                  color: "#8793a5",
                  fontSize: 10,
                  marginTop: 1,
                }}
              >
                {auth.currentUser?.email ||
                  users?.correo ||
                  ""}
              </div>
            </div>
          </div>
        </Modal.Header>

        {/* CONTENT */}
        <Modal.Content
          style={{
            padding: "14px 16px 12px",
          }}
        >
          {mensajePassword && (
            <Message
              positive
              size="tiny"
              style={{
                boxShadow: "none",
                margin: "0 0 10px 0",
                padding: "8px 10px",
              }}
            >
              <Icon name="check circle" />
              {mensajePassword}
            </Message>
          )}

          {errorPassword && (
            <Message
              negative
              size="tiny"
              style={{
                boxShadow: "none",
                margin: "0 0 10px 0",
                padding: "8px 10px",
              }}
            >
              <Icon name="warning sign" />
              {errorPassword}
            </Message>
          )}

          {!passwordCambiada && (
            <Form size="small">
              {/* CONTRASEÑA ACTUAL */}
              <Form.Field
                required
                style={{
                  marginBottom: 10,
                }}
              >
                <label
                  style={{
                    fontSize: 12,
                    marginBottom: 4,
                  }}
                >
                  Contraseña actual
                </label>

                <PasswordInput
                  value={passwordActual}
                  onChange={setPasswordActual}
                  mostrar={mostrarActual}
                  setMostrar={setMostrarActual}
                  placeholder="Contraseña actual"
                  autoComplete="current-password"
                  disabled={
                    cambiandoPassword ||
                    enviandoRecuperacion
                  }
                />

                <div
                  style={{
                    textAlign: "right",
                    marginTop: 4,
                  }}
                >
                  <button
                    type="button"
                    disabled={
                      enviandoRecuperacion ||
                      cambiandoPassword
                    }
                    onClick={
                      enviarRecuperacionPassword
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: enviandoRecuperacion
                        ? "#8793a5"
                        : "#2185d0",
                      fontSize: 10,
                      cursor: enviandoRecuperacion
                        ? "default"
                        : "pointer",
                    }}
                  >
                    {enviandoRecuperacion
                      ? "Enviando correo..."
                      : "¿Olvidaste tu contraseña?"}
                  </button>
                </div>
              </Form.Field>

              {/* NUEVA */}
              <Form.Field
                required
                style={{
                  marginBottom: 10,
                }}
              >
                <label
                  style={{
                    fontSize: 12,
                    marginBottom: 4,
                  }}
                >
                  Nueva contraseña
                </label>

                <PasswordInput
                  value={passwordNueva}
                  onChange={setPasswordNueva}
                  mostrar={mostrarNueva}
                  setMostrar={setMostrarNueva}
                  placeholder="Nueva contraseña"
                  autoComplete="new-password"
                  disabled={
                    cambiandoPassword ||
                    enviandoRecuperacion
                  }
                />
              </Form.Field>

              {/* CONFIRMAR */}
              <Form.Field
                required
                style={{
                  marginBottom: 8,
                }}
              >
                <label
                  style={{
                    fontSize: 12,
                    marginBottom: 4,
                  }}
                >
                  Confirmar nueva contraseña
                </label>

                <PasswordInput
                  value={passwordConfirmacion}
                  onChange={setPasswordConfirmacion}
                  mostrar={mostrarConfirmacion}
                  setMostrar={setMostrarConfirmacion}
                  placeholder="Confirmar nueva contraseña"
                  autoComplete="new-password"
                  disabled={
                    cambiandoPassword ||
                    enviandoRecuperacion
                  }
                />
              </Form.Field>

              {/* REGLAS */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "5px 10px",
                  padding: "7px 9px",
                  borderRadius: 6,
                  background: "#f8fafc",
                  border: "1px solid #e5e9ef",
                }}
              >
                <ReglaCompacta
                  cumple={reglaLargo}
                  texto="8+ caracteres"
                />

                <ReglaCompacta
                  cumple={reglaMayuscula}
                  texto="Mayúscula"
                />

                <ReglaCompacta
                  cumple={reglaMinuscula}
                  texto="Minúscula"
                />

                <ReglaCompacta
                  cumple={reglaNumero}
                  texto="Número"
                />

                <ReglaCompacta
                  cumple={reglaCoinciden}
                  texto="Coinciden"
                />
              </div>
            </Form>
          )}

          {passwordCambiada && (
            <div
              style={{
                textAlign: "center",
                padding: "12px 0 6px",
              }}
            >
              <Icon
                name="check circle"
                style={{
                  color: "#21ba45",
                  fontSize: 34,
                  margin: 0,
                }}
              />

              <div
                style={{
                  marginTop: 6,
                  color: "#253858",
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                Contraseña actualizada
              </div>
            </div>
          )}
        </Modal.Content>

        {/* ACTIONS */}
        <Modal.Actions
          style={{
            padding: "9px 12px",
            background: "#f8fafc",
            borderTop: "1px solid #e5e9ef",
          }}
        >
          <Button
            size="small"
            type="button"
            disabled={
              cambiandoPassword ||
              enviandoRecuperacion
            }
            onClick={cerrarModalPassword}
            style={{
              background: "#ffffff",
              color: "#526273",
              border: "1px solid #d7dee7",
              boxShadow: "none",
            }}
          >
            {passwordCambiada
              ? "Cerrar"
              : "Cancelar"}
          </Button>

          {!passwordCambiada && (
            <Button
              size="small"
              type="button"
              loading={cambiandoPassword}
              disabled={
                cambiandoPassword ||
                enviandoRecuperacion
              }
              onClick={cambiarPassword}
              style={{
                background: "#0d9da5",
                color: "#ffffff",
                boxShadow: "none",
              }}
            >
              {!cambiandoPassword && (
                <Icon name="key" />
              )}

              Actualizar
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    </>
  );
};

// ============================================================
// INPUT PASSWORD REUTILIZABLE
// ============================================================
const PasswordInput = ({
  value,
  onChange,
  mostrar,
  setMostrar,
  placeholder,
  autoComplete,
  disabled,
}) => {
  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <input
        type={
          mostrar
            ? "text"
            : "password"
        }
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) =>
          onChange(e.target.value)
        }
        style={{
          height: 36,
          padding: "7px 38px 7px 10px",
          fontSize: 12,
        }}
      />

      <Icon
        name={
          mostrar
            ? "eye slash"
            : "eye"
        }
        link
        onClick={() => {
          if (!disabled) {
            setMostrar(!mostrar);
          }
        }}
        style={{
          position: "absolute",
          right: 11,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#8793a5",
          margin: 0,
          zIndex: 2,
          fontSize: 13,
        }}
      />
    </div>
  );
};

// ============================================================
// REGLA PASSWORD COMPACTA
// ============================================================

const ReglaCompacta = ({
  cumple,
  texto,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems:
          "center",
        gap: 4,
        color: cumple
          ? "#21ba45"
          : "#8793a5",
        fontSize: 10,
        whiteSpace:
          "nowrap",
      }}
    >
      <Icon
        name={
          cumple
            ? "check circle"
            : "circle outline"
        }
        style={{
          margin: 0,
          fontSize: 10,
          color: cumple
            ? "#21ba45"
            : "#b6bec9",
        }}
      />

      {texto}
    </div>
  );
};

export default NavbarSesionSemantic;